<template>
  <div id="index">
    <el-container>
      <el-scrollbar :class="isCollapse ? 'menu_hide rightSide' : 'rightSide'">
        <el-main>
          <nav-bar></nav-bar>
          <!-- <el-breadcrumb
              separator-class="el-icon-arrow-right"
              class="mainBread"
            >
              <el-breadcrumb-item>首页</el-breadcrumb-item>
              <el-breadcrumb-item>设备管理</el-breadcrumb-item>
              <el-breadcrumb-item>空压机型号管理</el-breadcrumb-item>
            </el-breadcrumb> -->
          <template>
            <el-tabs v-model="ActiveTab">
              <el-tab-pane :label="$t('title.productLine')" name="KType">
                <template>
                  <el-button
                    type="primary"
                    icon="el-icon-circle-plus-outline"
                    @click="showDialog(true)"
                    style="margin-bottom: 10px"
                    v-show="hasCreateAuth"
                    >{{ $t("button.addProductLine") }}</el-button
                  >
                  <table-devicemodel
                    :isShowKType="false"
                    :isShowKSmall="false"
                    :isShowKKproduct="false"
                    :tableData="tableData1"
                    :tableType="(tableType = 'KType')"
                    :hasUpdateAuth="hasUpdateAuth"
                    :hasDeleteAuth="hasDeleteAuth"
                    @showEditDialog="showEditDialog"
                    @delRow="delRow"
                  >
                  </table-devicemodel>
                  <el-pagination
                    background
                    :page-size="pagination1.pageSize"
                    :page-sizes="[10, 20, 50]"
                    @current-change="handleCurrentChange1"
                    @size-change="handleSizeChange1"
                    layout="prev, pager, next,sizes"
                    :total="pagination1.totalPage"
                    style="text-align: center; margin-top: 10px"
                  >
                  </el-pagination>
                </template>
              </el-tab-pane>
              <el-tab-pane
                :label="$t('title.productCategories')"
                name="KProduct"
              >
                <template>
                  <el-button
                    type="primary"
                    icon="el-icon-circle-plus-outline"
                    @click="showDialog(true)"
                    style="margin-bottom: 10px"
                    v-show="hasCreateAuth"
                    >{{ $t("button.addProductCategories") }}</el-button
                  >
                  <table-devicemodel
                    :isShowKType="true"
                    :isShowKSmall="false"
                    :isShowKKproduct="false"
                    :tableData="tableData2"
                    :tableType="(tableType = 'KProduct')"
                    :hasUpdateAuth="hasUpdateAuth"
                    :hasDeleteAuth="hasDeleteAuth"
                    @showEditDialog="showEditDialog"
                    @delRow="delRow"
                  >
                  </table-devicemodel>
                  <el-pagination
                    background
                    :page-size="pagination2.pageSize"
                    :page-sizes="[10, 20, 50]"
                    @current-change="handleCurrentChange2"
                    @size-change="handleSizeChange2"
                    layout="prev, pager, next,sizes"
                    :total="pagination2.totalPage"
                    style="text-align: center; margin-top: 10px"
                  >
                  </el-pagination>
                </template>
              </el-tab-pane>
              <el-tab-pane :label="$t('title.smallClassProduct')" name="KSmall">
                <template>
                  <el-button
                    type="primary"
                    icon="el-icon-circle-plus-outline"
                    @click="showDialog(true)"
                    style="margin-bottom: 10px"
                    v-show="hasCreateAuth"
                    >{{ $t("button.addSmallClassProduct") }}</el-button
                  >
                  <table-devicemodel
                    :isShowKType="true"
                    :isShowKSmall="true"
                    :isShowKKproduct="false"
                    :tableData="tableData3"
                    :tableType="(tableType = 'KSmall')"
                    :hasUpdateAuth="hasUpdateAuth"
                    :hasDeleteAuth="hasDeleteAuth"
                    @showEditDialog="showEditDialog"
                    @delRow="delRow"
                  >
                  </table-devicemodel>
                  <el-pagination
                    background
                    :page-size="pagination3.pageSize"
                    :page-sizes="[10, 20, 50]"
                    @current-change="handleCurrentChange3"
                    @size-change="handleSizeChange3"
                    layout="prev, pager, next,sizes"
                    :total="pagination3.totalPage"
                    style="text-align: center; margin-top: 10px"
                  >
                  </el-pagination>
                </template>
              </el-tab-pane>
              <el-tab-pane :label="$t('title.machineType')" name="KPower">
                <el-form
                  ref="formselect"
                  v-model="formselect"
                  class="queryform_div"
                  label-width="100px"
                >
                  <el-row :gutter="24">
                    <el-col :md="8" :xs="24" :sm="24">
                      <el-form-item :label="$t('title.machineType')">
                        <el-input
                          size="small"
                          style="width: 100%"
                          v-model="formselect.name"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :md="6" :xs="24" :sm="24" style="margin-top: 10px">
                      <el-button
                        @click="getTableList('4', 'search')"
                        type="primary"
                        size="small"
                        >{{ $t("button.query") }}</el-button
                      >
                      <el-button @click="resetKeyword" size="small">{{
                        $t("button.reset")
                      }}</el-button>
                    </el-col>
                  </el-row>
                </el-form>

                <template>
                  <el-button
                    type="primary"
                    icon="el-icon-circle-plus-outline"
                    @click="showDialog(true)"
                    style="margin-bottom: 10px"
                    v-show="hasCreateAuth"
                    >{{ $t("button.addMachineType") }}</el-button
                  >
                  <el-button
                    type="default"
                    icon="el-icon-download"
                    style="margin-bottom: 10px"
                    @click="exportDeviceModelList()"
                    :loading="loading"
                    v-if="hasExportAuth"
                    >{{ $t("button.exportAll") }}</el-button
                  >
                  
                  <el-button
                    type="default"
                    icon="el-icon-upload2"
                    @click="showImportDialog(true)"
                    style="margin-bottom: 10px; text-decoration: none; float: right"
                    v-show="hasCreateAuth"
                    >{{ $t("button.bulkImport") }}</el-button
                  >
                  <a
                    v-if="activeLang == 'en'"
                    class="el-button el-button--default el-button--small"
                    style="margin-bottom: 10px; text-decoration: none; float: right"
                    href="/file/Excel Import Template - Air Compression Models List.xlsx"
                    download="Excel Import Template - Air Compression Models List.xlsx"
                    >{{ $t("desc.exportTemplate") }}</a
                  >
                  <a
                    v-else
                    class="el-button el-button--default el-button--small"
                    style="margin-bottom: 10px; text-decoration: none; float: right"
                    href="/file/EXCEL导入模板-空压机机型列表.xlsx"
                    download="EXCEL导入模板-空压机机型列表.xlsx"
                    >{{ $t("desc.exportTemplate") }}</a
                  >
                  <table-devicemodel
                    :isShowKType="true"
                    :isShowKSmall="true"
                    :isShowKKproduct="true"
                    :tableData="tableData4"
                    :tableType="(tableType = 'KPower')"
                    :hasUpdateAuth="hasUpdateAuth"
                    :hasDeleteAuth="hasDeleteAuth"
                    @showEditDialog="showEditDialog"
                    @delRow="delRow"
                  >
                  </table-devicemodel>
                  <el-pagination
                    background
                    :page-size="pagination4.pageSize"
                    :page-sizes="[10, 20, 50]"
                    @current-change="handleCurrentChange4"
                    @size-change="handleSizeChange4"
                    layout="prev, pager, next,sizes"
                    :total="pagination4.totalPage"
                    style="text-align: center; margin-top: 10px"
                  >
                  </el-pagination>
                </template>
              </el-tab-pane>
            </el-tabs>
          </template>
        </el-main>
      </el-scrollbar>
    </el-container>
    <dialog-ktype
      ref="addRef1"
      :dialogAddClient="dialogAdd1"
      :formRef="'kTypeAddRef'"
      :title="(dialogTitle = $t('title.addProductLine'))"
      :KTypeform="KTypeform"
      :subButtonAuth="hasCreateAuth"
      :brandInfo="brandInfo"
      :loading="submitLoading"
      @dialogVisibleEvent="showDialog"
      @onSubBtn="addDeviceModel"
    >
    </dialog-ktype>

    <dialog-kproduct
      ref="addRef2"
      :dialogAddClient="dialogAdd2"
      :formRef="'kProductAddRef'"
      :title="(dialogTitle = $t('button.addProductCategories'))"
      :KProductform="KProductform"
      :MTypeTable="tableData1"
      :subButtonAuth="hasCreateAuth"
      :brandInfo="brandInfo"
      :loading="submitLoading"
      @dialogVisibleEvent="showDialog"
      @onSubBtn="addDeviceModel"
    >
    </dialog-kproduct>

    <dialog-ksmall
      ref="addRef3"
      :dialogAddClient="dialogAdd3"
      :formRef="'kSmallAddRef'"
      :title="(dialogTitle = $t('button.addSmallClassProduct'))"
      :KSmallform="KSmallform"
      :MTypeTable="tableData1"
      :MProductTable="MPOptions"
      :subButtonAuth="hasCreateAuth"
      :brandInfo="brandInfo"
      :loading="submitLoading"
      @selMTChange="selMTChange"
      @dialogVisibleEvent="showDialog"
      @onSubBtn="addDeviceModel"
    >
    </dialog-ksmall>

    <dialog-kpower
      ref="addRef4"
      :dialogAddClient="dialogAdd4"
      :formRef="'kPowerAddRef'"
      :title="(dialogTitle = $t('title.addMachineType'))"
      :KPowerform="KPowerform"
      :MTypeTable="tableData1"
      :MProductTable="MPOptions"
      :MSmallTable="MSOptions"
      :subButtonAuth="hasCreateAuth"
      :picList="brandImgList"
      :imageId="imageId"
      :brandInfo="brandInfo"
      :productFamilyList="productFamilyList"
      :loading="submitLoading"
      @changeBrand="changeBrand"
      @selImag="selImag"
      @selMTChange="selMTChange"
      @selMPChange="selMPChange"
      @dialogVisibleEvent="showDialog"
      @onSubBtn="addDeviceModel"
    >
    </dialog-kpower>

    <dialog-ktype
      ref="editRef1"
      :dialogAddClient="dialogEdit1"
      :formRef="'kTypeEditRef'"
      :title="(dialogTitle = $t('title.updateProductLine'))"
      :KTypeform="KTypeform"
      :subButtonAuth="hasUpdateAuth"
      :brandInfo="brandInfo"
      :loading="submitLoading"
      @dialogVisibleEvent="showEditDialog"
      @onSubBtn="updateDeviceModel"
    >
    </dialog-ktype>

    <dialog-kproduct
      ref="editRef2"
      :dialogAddClient="dialogEdit2"
      :formRef="'kProductEditRef'"
      :title="(dialogTitle = $t('title.updateProductCategories'))"
      :KProductform="KProductform"
      :MTypeTable="MTOptions"
      :subButtonAuth="hasUpdateAuth"
      :brandInfo="brandInfo"
      :loading="submitLoading"
      @dialogVisibleEvent="showEditDialog"
      @onSubBtn="updateDeviceModel"
    >
    </dialog-kproduct>

    <dialog-ksmall
      ref="editRef3"
      :dialogAddClient="dialogEdit3"
      :formRef="'kSmallEditRef'"
      :title="(dialogTitle = $t('title.updateSmallClassProduct'))"
      :KSmallform="KSmallform"
      :MTypeTable="MTOptions"
      :MProductTable="MPOptions"
      :subButtonAuth="hasUpdateAuth"
      :brandInfo="brandInfo"
      :loading="submitLoading"
      @dialogVisibleEvent="showEditDialog"
      @onSubBtn="updateDeviceModel"
    >
    </dialog-ksmall>

    <dialog-kpower
      ref="editRef4"
      :dialogAddClient="dialogEdit4"
      :formRef="'kPowerEditRef'"
      :title="(dialogTitle = $t('title.updateMachineType'))"
      :KPowerform="KPowerform"
      :MTypeTable="MTOptions"
      :MProductTable="MPOptions"
      :MSmallTable="MSOptions"
      :subButtonAuth="hasUpdateAuth"
      :picList="brandImgList"
      :imageId="imageId"
      :brandInfo="brandInfo"
      :productFamilyList="productFamilyList"
      :loading="submitLoading"
      @changeBrand="changeBrand"
      @selImag="selImag"
      @dialogVisibleEvent="showEditDialog"
      @onSubBtn="updateDeviceModel"
    >
    </dialog-kpower>
    
    <import-dialog
      ref="importRef"
      :refForm="'airFormImport'"
      :title="(dialogTitle = $t('title.batchImportModel'))"
      :dialogImportClient="dialogImportClient"
      :form="form"
      @onSubBtn="uploadFile"
      @dialogVisibleEvent="showImportDialog"
    ></import-dialog>
  </div>
</template>

<script>
import {
  getDeviceModelTablePage,
  getDeviceModelById,
  deleteDeviceModel,
  updateDeviceModel,
  getDeviceModelOption,
  addDeviceModel,
  importDeviceModel,
  authOperationCheck,
  getDeviceImageList,
  exportExcelNew,
  getBrandInfos,
  getProductFamilyList
} from "../../api/api";
import { mapState, mapGetters } from "vuex";

import qs from "qs";
import dialogDeviceType from "../../components/content/deviceModel/DialogDeviceType";
import dialogPower from "../../components/content/deviceModel/DialogPower";
import dialogProductSmall from "../../components/content/deviceModel/DialogProductSmall";
import dialogProductType from "../../components/content/deviceModel/DialogProductType";
import tableDeviceType from "../../components/content/deviceModel/TableDeviceType";
import importComponent from "../../components/content/maintabber/ImportExcelFiles";

export default {
  name: "index",
  components: {
    "dialog-ktype": dialogDeviceType,
    "dialog-kpower": dialogPower,
    "dialog-kproduct": dialogProductType,
    "dialog-ksmall": dialogProductSmall,
    "table-devicemodel": tableDeviceType,
    "import-dialog": importComponent,
  },
  computed: {
  ...mapState({
    isCollapse: (state) => state.isCollapse,
  }),
  ...mapGetters({
    activeLang: "language",
  }),
},
  data() {
    return {
      submitLoading:false,
      loading:false,
      ActiveTab: "KType",
      tableType: "",
      dialogTitle: "",
      dialogAdd1: false,
      dialogAdd2: false,
      dialogAdd3: false,
      dialogAdd4: false,

      dialogEdit1: false,
      dialogEdit2: false,
      dialogEdit3: false,
      dialogEdit4: false,

      hasUpdateAuth: false,
      hasDeleteAuth: false,
      hasCreateAuth: false,
      hasExportAuth: false,

      tableData1: [],
      tableData2: [],
      tableData3: [],
      tableData4: [],

      MTOptions: [],
      MPOptions: [],
      MSOptions: [],
      TotalOptions: [],
      KTypeform: {
        KTypeId: "",
        KType: "",
        Level: "1",
      },
      KProductform: {
        KTypeId: "",
        KType: "",
        KProductId: "",
        kProduct: "",
        Level: "2",
      },
      KSmallform: {
        kTypeId: "",
        kType: "",
        kProductId: "",
        kProduct: "",
        kSmallId: "",
        kSmall: "",
        Level: "3",
        fileList: [],
      },
      KPowerform: {
        KTypeId: "",
        KType: "",
        KProductId: "",
        kProduct: "",
        KSmallId: "",
        KSmall: "",
        KPower: "",
        KPowerId: "",
        Level: "4",
        ImgId: "",
      },
      imageId: "",
      pagination1: {
        current: 1,
        pageSize: 10,
        totalPage: 0,
      },
      pagination2: {
        current: 1,
        pageSize: 10,
        totalPage: 0,
      },
      pagination3: {
        current: 1,
        pageSize: 10,
        totalPage: 0,
      },
      pagination4: {
        current: 1,
        pageSize: 10,
        totalPage: 0,
      },
      formselect: {},
      imgList: [],
      brandImgList:[],
      brandInfo:{},
      productFamilyList:[],
      dialogImportClient: false,
      form: {
        datalist: [],
      },
    };
  },
  created: function () {
    this.authOperation("DeviceModel");
  },
  async mounted() {
    this.getTableList("1");
    this.getTableList("2");
    this.getTableList("3");
    this.getTableList("4");
    this.getTotalOption();
    this.getBrandInfos();
    this.getProductFamilyList();
  },
  methods: {
    
    authOperation(curPage) {
      var that = this;
      var res = authOperationCheck(curPage);
      that.hasCreateAuth = res.hasCreateAuth;
      that.hasUpdateAuth = res.hasUpdateAuth;
      that.hasDeleteAuth = res.hasDeleteAuth;
      that.hasExportAuth = res.hasExportAuth;
    },
    async getProductFamilyList(){
      let that =this;
      let res = await getProductFamilyList();
      that.productFamilyList = res.result;
    },
    changeBrand(brandCode){
      // this.brandImgList=this.imgList.filter(a=>a.brandCode===brandCode && a.brandCode!=null);
    },
    async getBrandInfos(){
      let that=this;
      let res = await getBrandInfos();
      let brandCode=localStorage.getItem("user_brand")?localStorage.getItem("user_brand"):"IR";
      that.brandInfo = res.result.find(x=>x.brandCode==brandCode);
    },
    getTotalOption() {
      let that = this;
      getDeviceModelOption().then((res) => {
        let data = res.result;
        that.TotalOptions = data;
      });
    },
    getTableList(type, search = "normal") {
      let that = this;
      let skipcount = 0;
      let maxResultCount = 10;
      if (type == "1") {
        if (search == "search") {
          this.pagination1.current = 1;
        }
        skipcount = (this.pagination1.current - 1) * this.pagination1.pageSize;
        maxResultCount = this.pagination1.pageSize;
      } else if (type == "2") {
        if (search == "search") {
          this.pagination2.current = 1;
        }
        skipcount = (this.pagination2.current - 1) * this.pagination2.pageSize;
        maxResultCount = this.pagination2.pageSize;
      } else if (type == "3") {
        if (search == "search") {
          this.pagination3.current = 1;
        }
        skipcount = (this.pagination3.current - 1) * this.pagination3.pageSize;
        maxResultCount = this.pagination3.pageSize;
      } else if (type == "4") {
        if (search == "search") {
          this.pagination4.current = 1;
        }
        skipcount = (this.pagination4.current - 1) * this.pagination4.pageSize;
        maxResultCount = this.pagination4.pageSize;
      }

      let PostData = {
        KeyWord: type,
        SkipCount: skipcount,
        MaxResultCount: maxResultCount,
        SerchWord: this.formselect.name,
      };
      getDeviceModelTablePage(PostData).then((res) => {
        let data = res.result;
        if (type == "1") {
          that.tableData1 = data.items;
          this.pagination1.totalPage = res.result.totalCount;
        } else if (type == "2") {
          that.tableData2 = data.items;
          this.pagination2.totalPage = res.result.totalCount;
        } else if (type == "3") {
          that.tableData3 = data.items;
          this.pagination3.totalPage = res.result.totalCount;
        } else if (type == "4") {
          that.tableData4 = data.items;
          this.pagination4.totalPage = res.result.totalCount;
          this.getProductFamilyList();
        }
      });
    },

    addDeviceModel() {
      let that = this;
      that.submitLoading = true;
      let dataPost = {};
      if (that.ActiveTab == "KType") {
        dataPost = that.KTypeform;
      } else if (that.ActiveTab == "KProduct") {
        dataPost = that.KProductform;
      } else if (that.ActiveTab == "KSmall") {
        dataPost = that.KSmallform;
      } else {
        dataPost = that.KPowerform;
      }
      addDeviceModel(dataPost)
        .then((res) => {
          that.submitLoading = false;
          that.showDialog(false, that.ActiveTab);
          that.$message({
            showClose: true,
            message: that.$t("tips.saveSuccess"),
            type: "success",
          });
          that.getTableList("1");
          that.getTableList("2");
          that.getTableList("3");
          that.getTableList("4");
          this.getTotalOption();
        })
        .catch((err) => {
          that.submitLoading = false;
          if (err != undefined) {
            that.$message({
              showClose: true,
              message: err.error.message,
              type: "error",
            });
          }
        });
    },
    updateDeviceModel() {
      let that = this;
      that.submitLoading = true;
      let dataPost = {};
      if (that.ActiveTab == "KType") {
        dataPost = that.KTypeform;
      } else if (that.ActiveTab == "KProduct") {
        dataPost = that.KProductform;
      } else if (that.ActiveTab == "KSmall") {
        dataPost = that.KSmallform;
      } else {
        dataPost = that.KPowerform;
      }
      updateDeviceModel(dataPost)
        .then((res) => {
          that.submitLoading = false;
          that.dialogEdit1 = false;
          that.dialogEdit2 = false;
          that.dialogEdit3 = false;
          that.dialogEdit4 = false;
          that.$message({
            showClose: true,
            message: that.$t("tips.updateSuccess"),
            type: "success",
          });
          that.getTableList("1");
          that.getTableList("2");
          that.getTableList("3");
          that.getTableList("4");
          this.getTotalOption();
          this.resetFormData();
        })
        .catch((err) => {
          that.submitLoading = false;
          if (err != undefined) {
            that.$message({
              showClose: true,
              message: err.error.message,
              type: "error",
            });
          }
        });
    },
    delRow(index, row, type) {
      let that = this;
      let data = { Id: row.id };
      deleteDeviceModel(data)
        .then((res) => {
          that.$message({
            showClose: true,
            message: this.$t("tips.deleteSuccess"),
            type: "success",
          });
          //删除成功直接js处理，也可以后台再获取一遍数据 分页不建议js处理 暂时不改
          if (type == "KType") {
            that.tableData1.splice(index, 1);
          } else if (type == "KProduct") {
            that.tableData2.splice(index, 1);
          } else if (type == "KSmall") {
            that.tableData3.splice(index, 1);
          } else {
            that.tableData4.splice(index, 1);
          }
        })
        .catch((err) => {
          if (err != undefined) {
            that.$message({
              showClose: true,
              message: err.error.message,
              type: "error",
            });
          }
        });
    },
    async GetDeviceImageList() {
      let that = this;
      await getDeviceImageList().then((res) => {
        let data = res.result;
        this.imgList = data;
        this.brandImgList=this.imgList.filter(a=>a.brandCode===this.brandInfo.brandCode && a.brandCode!=null);
        that.imageId = that.KPowerform.imgId;
      });
    },
    showDialog(visible, row) {
      if (this.ActiveTab == "KType") {
        this.dialogAdd1 = visible;
      } else if (this.ActiveTab == "KProduct") {
        this.dialogAdd2 = visible;
      } else if (this.ActiveTab == "KSmall") {
        this.dialogAdd3 = visible;
      } else {
        this.dialogAdd4 = visible;
      }
      //每次打开dialog清楚表格数据
      if (visible) {
        this.MSOptions = [];
        this.MPOptions = [];
        this.resetFormData();
        //打开窗口前重置验证
        if (this.$refs.addRef1.$refs.kTypeAddRef != undefined) {
          this.$refs.addRef1.$refs.kTypeAddRef.resetFields();
        }
        if (this.$refs.addRef2.$refs.kProductAddRef != undefined) {
          this.$refs.addRef2.$refs.kProductAddRef.resetFields();
        }
        if (this.$refs.addRef3.$refs.kSmallAddRef != undefined) {
          this.$refs.addRef3.$refs.kSmallAddRef.resetFields();
        }
        if (this.$refs.addRef4.$refs.kPowerAddRef != undefined) {
          this.$refs.addRef4.$refs.kPowerAddRef.resetFields();
        }

        this.$set(this.KTypeform, "brandCode", this.brandInfo.brandCode);
        this.$set(this.KProductform, "brandCode", this.brandInfo.brandCode);
        this.$set(this.KSmallform, "brandCode", this.brandInfo.brandCode);
        this.$set(this.KPowerform, "brandCode", this.brandInfo.brandCode);

        if (this.ActiveTab == "KPower" && this.imgList == 0) {
          this.GetDeviceImageList();
        }
      }
    },
    async showEditDialog(visible, row) {
      if (this.ActiveTab == "KType") {
        this.dialogEdit1 = visible;
      } else if (this.ActiveTab == "KProduct") {
        this.dialogEdit2 = visible;
      } else if (this.ActiveTab == "KSmall") {
        this.dialogEdit3 = visible;
      } else {
        this.dialogEdit4 = visible;
      }
      if (visible) {
        
        //打开窗口前重置验证
        if (this.$refs.editRef1.$refs.kTypeEditRef != undefined) {
          this.$refs.editRef1.$refs.kTypeEditRef.resetFields();
        }
        if (this.$refs.editRef2.$refs.kProductEditRef != undefined) {
          this.$refs.editRef2.$refs.kProductEditRef.resetFields();
        }
        if (this.$refs.editRef3.$refs.kSmallEditRef != undefined) {
          this.$refs.editRef3.$refs.kSmallEditRef.resetFields();
        }
        if (this.$refs.editRef4.$refs.kPowerEditRef != undefined) {
          this.$refs.editRef4.$refs.kPowerEditRef.resetFields();
        }
        if (this.ActiveTab == "KPower" && this.imgList.length == 0) {
          await this.GetDeviceImageList();
        }
        await this.changeBrand(row.brandCode);
        await this.getDeviceModelById(this.ActiveTab, row);
        
      } else {
        this.resetFormData();
      }
    },

    async getDeviceModelById(type, row) {
      let that = this;
      let data = { id: row.id, type: type };
      await getDeviceModelById(data).then((res) => {
        let data = res.result;
        that.MTOptions = that.tableData1.filter(
          (item) => item.id === data.kTypeId
        );
        that.MPOptions = that.TotalOptions.filter(
          (item) => item.id === data.kProductId && item.level == "2"
        );
        that.MSOptions = that.TotalOptions.filter(
          (item) => item.id === data.kSmallId && item.level == "3"
        );
        if (type == "KType") {
          that.KTypeform = data;
        } else if (type == "KProduct") {
          that.KProductform = data;
        } else if (type == "KSmall") {
          that.KSmallform = data;
        } else {
          that.KPowerform = data;
          if (this.ActiveTab == "KPower" && this.imgList.length == 0) {
          } else {
            that.imageId = data.imgId;
          }
        }
      });
    },
    resetFormData() {
      this.KTypeform = {
        KTypeId: "",
        KType: "",
        level: "1",
      };
      this.KProductform = {
        KTypeId: "",
        KType: "",
        KProductId: "",
        kProduct: "",
        level: "2",
      };
      this.KSmallform = {
        KTypeId: "",
        KType: "",
        KProductId: "",
        kProduct: "",
        KSmallId: "",
        KSmall: "",
        level: "3",
      };
      this.KPowerform = {
        KTypeId: "",
        KType: "",
        KProductId: "",
        kProduct: "",
        KSmallId: "",
        KSmall: "",
        KPower: "",
        KPowerId: "",
        level: "4",
        ImgId: "",
      };
      this.imageId = "";
    },
    selMTChange(value) {
      this.MPOptions = this.TotalOptions.filter(
        (item) => item.parentId === value && item.level == "2"
      );
      //修改空压机类型时，产品小类下拉框置空
      this.MSOptions = [];
      this.$set(this.KSmallform, "kProductId", "");
      this.$set(this.KPowerform, "kSmallId", "");
      this.$set(this.KPowerform, "kProductId", "");
      // this.KSmallform.kProduct="";
      // this.KPowerform.kSmall="";
      // this.KPowerform.kProduct="";
    },
    selMPChange(value) {
      this.MSOptions = this.TotalOptions.filter(
        (item) => item.parentId === value && item.level == "3"
      );
      this.$set(this.KPowerform, "kSmallId", "");
      // this.KPowerform.kSmall="";
    },
    selImag(value) {
      this.KPowerform.imgId = value;
      // this.imageId= value;
    },
    handleClick(tab, event) {},
    handleCurrentChange1(val) {
      this.pagination1.current = val;
      this.getTableList("1");
    },
    handleSizeChange1(val) {
      this.pagination1.pageSize = val;
      this.getTableList("1");
    },
    handleCurrentChange2(val) {
      this.pagination2.current = val;
      this.getTableList("2");
    },
    handleSizeChange2(val) {
      this.pagination2.pageSize = val;
      this.getTableList("2");
    },
    handleCurrentChange3(val) {
      this.pagination3.current = val;
      this.getTableList("3");
    },
    handleSizeChange3(val) {
      this.pagination3.pageSize = val;
      this.getTableList("3");
    },
    handleCurrentChange4(val) {
      this.pagination4.current = val;
      this.getTableList("4");
    },
    handleSizeChange4(val) {
      this.pagination4.pageSize = val;
      this.getTableList("4");
    },

    resetKeyword() {
      this.formselect = {};
    },
    exportDeviceModelList() {
      let that = this;
      that.loading=true;
      var exportData=[[
        that.$t("title.productLine"), 
        that.$t("title.productCategories"),
        that.$t("title.smallClassProduct"),
        that.$t("title.machineType"),
        that.$t("title.brandName"),
        that.$t("title.imageName"),
        that.$t("title.productFamily"),
        that.$t("title.power"),
        that.$t("title.dischargePressure"),
        that.$t("title.coolingMode")
      ]]

      var fileName = that.$t("exportContent.空压机机型列表") + ".xlsx";
      let postData = {
        KeyWord: "4",
        SkipCount: 0,
        MaxResultCount: 10000,
        SerchWord: this.formselect.name,
      };
      getDeviceModelTablePage(postData).then((res) => {
        if (res.result) {
          let data = res.result.items;
          // this.pagination.totalPage = res.result.totalCount;
          //导入数据里有null会导致文件损坏
          const dataSource = data.map((item) => {
            Object.keys(item).forEach((key) => {
              // 后端传null node写入会有问题
              if (item[key] === null) {
                item[key] = "";
              }

              if (Array.isArray(item[key])) {
                item[key] = item[key].join(",");
              }
            });
            return item;
          });
          dataSource.forEach(item=>{
            let rowData = []
                rowData = [
                    item.kType,
                    item.kProduct,
                    item.kSmall,
                    item.kPower,
                    item.brand,
                    item.imgName,
                    item.productFamily,
                    item.power,
                    item.dischargePressure,
                    that.translatecoodType(item.coolingMode),
                ]
                exportData.push(rowData)
          })
          exportExcelNew(exportData,fileName);
          // exportExcel(headers, dataSource, fileName);
          that.loading=false;
        }
      });
    },
    translatecoodType(name){
      return this.$t('coodMode.'+name).indexOf(".")>-1?name:this.$t('coodMode.'+name)
    },
    
    showImportDialog(visible) {
      this.dialogImportClient = visible;
      // this.form.datalist = [];
      if (this.$refs.importRef.$refs.airFormImport != undefined) {
        this.$refs.importRef.$refs.airFormImport.resetFields();
      }
    },

    uploadFile() {
      let that = this;
      var datalist = that.form.datalist;
      var dbData = [];
      var errInfoData = [];
      var msgArr = [];
      datalist.forEach((e, i) => {
        var propertys = Object.keys(e);

        var index = 2;
        if (that.activeLang == "en") {
          if (e.sheetName == "Sheet1") {
            e.data.map((v) => {
              let obj = {};
              obj.kType = v["Product Line"];
              obj.kProduct = v["Product Category"];
              obj.kSmall = v["Power Range"];
              obj.kPower = v["Model"];
              obj.brandCode = v["Brand Name"];
              obj.imgName = '';
              obj.productFamily = v["Product Family"];
              obj.power = v["Power"];
              obj.dischargePressure = v["Discharge Pressure"];
              obj.coolingMode = v["Cooling Mode"];
              obj.level = "";
              obj.file = "";
              obj.brand = "";
              obj.productFamilyName = "";

              if (dbData.find(item => item === obj) !== undefined) {
                msgArr.push(
                  that.$t("importError.exceptionLine")
                );
              } else {
                dbData.push(obj);
              }
              index++;
            });
          } else {
            msgArr.push(that.$t("importError.readFailCcn"));
          }
        } else {
          if (e.sheetName == "Sheet1") {
            e.data.map((v) => {
              let obj = {};
              obj.kType = v["产品线"];
              obj.kProduct = v["产品大类"];
              obj.kSmall = v["产品小类"];
              obj.kPower = v["机型"];
              obj.brandCode = v["品牌名称"];
              obj.imgId = '';
              obj.imgName = v["图片名称"];
              obj.productFamily = v["产品族"];
              obj.power = v["功率"];
              obj.dischargePressure = v["排气压力"];
              obj.coolingMode = v["冷却方式"];
              obj.level = "";
              obj.file = "";
              obj.brand = "";
              obj.productFamilyName = "";
              if ( dbData.find(item => item === obj) !== undefined ) {
                msgArr.push(
                  that.$t("importError.exceptionLine") 
                );
              } else {
                dbData.push(obj);
              }
              index++;
            });
          } else {
            msgArr.push("Excel表格读取失败，未找到“Sheet1”的Sheet");
          }
        }
      });
      if (msgArr.length > 0) {
        that.$message({
          showClose: true,
          dangerouslyUseHTMLString: true,
          message: msgArr.join("<br/>"),
          type: "error",
        });
        return false;
      }
      // var postData = {
      //   CcnType: that.curType,
      //   CcnGatherFulls: dbData,
      //   CcnGatherReturnFulls: errInfoData,
      // };
      importDeviceModel(dbData)
        .then((res) => {
          that.dialogImportClient = false;
          that.$message({
            showClose: true,
            message: that.$t("tips.importSuccess"),
            type: "success",
          });
          that.getProductFamilyList()
        })
        .catch((err) => {
          that.$message({
            showClose: true,
            message: err.error.message,
            type: "error",
          });
        });
    },
  },
};
</script>

<style>
</style>
